module.exports = __webpack_public_path__ + "static/img/link4.b049c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/page/links/link4.png
// module id = JlCM
// module chunks = 12